// extracted by mini-css-extract-plugin
export var deleteModal = "_eg-0";